import { ARDOQ_DEFAULT_FONT_FAMILY } from '@ardoq/typography';

export const MODERNIZED_BLOCK_DIAGRAM_FONT_SIZE = 12;
export const MODERNIZED_BLOCK_DIAGRAM_LINE_HEIGHT = 14;
const WEIGHTLESS_MODERNIZED_BLOCK_DIAGRAM_FONT = `${MODERNIZED_BLOCK_DIAGRAM_FONT_SIZE}px/${MODERNIZED_BLOCK_DIAGRAM_LINE_HEIGHT}px ${ARDOQ_DEFAULT_FONT_FAMILY}`;
export const MODERNIZED_BLOCK_DIAGRAM_FONT = `500 ${WEIGHTLESS_MODERNIZED_BLOCK_DIAGRAM_FONT}`;
export const MODERNIZED_BLOCK_DIAGRAM_OPEN_GROUP_SUBLABEL_FONT = `400 ${WEIGHTLESS_MODERNIZED_BLOCK_DIAGRAM_FONT}`;
